import AddBook from "../../Components/Modals/AddBook";
import Table from "../../Components/Table";
import {  deleteBookById, getAllBookPagination } from "../../Services/MasterService";

const Book = () => {
    // name, state_id, status, logo, id
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Author",
            value: "author"
        },

        {
            label: "Description",
            value: "description",
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddBook data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllBookPagination}
            columns={columns}
            title={"Books Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteBookById}
        />
    );
}

export default Book;